/* lua.js generated code 0.1 */

// 0 - disable debug info, 1 - less debug info, 2 - verbose debug info
DEBUG = __DEBUG
CC_USE_FRAMEWORK = true
CC_SHOW_FPS = __DEBUG
CLOVER_DEVELOP = 0  // __WIN32 || __DEBUG
CC_DESIGN_RESOLUTION = table(
    [1, "width", 720],
    [1, "height", 1280],
    [1, "autoscale", "FIXED_HEIGHT"],
    [1, "callback", function (framesize) {
        var ratio = framesize.width / framesize.height

        // 桌面
        if (cc.sys.platform === cc.sys.DESKTOP_BROWSER && ratio > 0.75) {
            return [{ autoscale: "SHOW_ALL" }]
        } else if (ratio <= 1.34) {
            // iPad 768*1024(1536*2048) is 4:3 screen
            return [{ autoscale: "FIXED_WIDTH" }]
        }
        return []
    }]
)

LOCAL_USER_KEY = "_local_user_key_"
LOCAL_IDENTIFY_KEY = "_local_identify_key_"
LOCAL_LAST_PASS_LEVEL_INFO = "_local_last_pass_level_info_"
LOCAL_LAST_PASS_LEVEL_INFO = "_local_platform_info_"
LOCAL_SETTING_KEY = "_local_setting_key_"
LOCAL_NEW_USER_REWARD_GETED_KEY = "_local_new_user_reward_"
LOCAL_LAST_BATCH_REPLAY_IN_LEVEL = "_local_last_batch_replay_in_level_"
LOCAL_SHORTCUT_PANEL_SHOWING = "_local_shortcut_panel_showing_"
LOCAL_SHORTCUT_RED_DOT = "_local_shortcut_red_dot_"
LOCAL_ONLINE_TIME = "_local_online_time_"
LOCAL_LAST_COIN_MATCH_RECORD = "_local_last_coin_match_record_"
LOCAL_LAST_GOLD_MATCH_RECORD = "_local_last_gold_match_record_"
LOCAL_GAMEBOARD_SPEED_SELECT = "_local_gameboard_speed_select_"
LOCAL_GAMEBOARD_SPEED_SELECT_GUIDE = "_local_gameboard_speed_select_guide"
LOCAL_LAST_TIME_MATCH_RECORD = "_local_last_time_match_record_"
LOCAL_STRATEGY_CHECK_TIP = "_local_strategy_check_tip_"
LOCAL_FAIL_LEVEL_AD_TIME = "_local_fail_level_ad_time_"
LOCAL_FAIL_LEVEL_SHARE_TIME = "_local_fail_level_share_time_"
LOCAL_PASS_LEVEL_SHOWOFF_FIRST = "_local_pass_level_showoff_first_"
LOCAL_LAST_SHOWOFF_TIME = "_local_last_showoff_time_"